import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { RechargesService } from '../../services/requests/recharges.service';
import { GlobalService } from "../../services/global.service";

@Component({
  selector: 'app-recharge',
  templateUrl: './recharge.component.html',
  styleUrls: ['./recharge.component.css']
})
export class RechargeComponent implements OnInit {
  ports: any = [];
  slots: any = [];
  detail: any = [];
  init: any = [1, 2, 3, 4];
  amount: number | null = null;
  upload = false;
  nbImporter = 0;
  files: Array<File> = [];
  quotaProchainCode?: number;
  ligne = Array(64).fill(false);
  colonne = Array(4).fill(false);
  all = false;
  actuel = Date.now();
  isLoading = false;

  constructor(
    private route: ActivatedRoute,
    private rechargesService: RechargesService,
    private globalService: GlobalService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.rechargesService.getNombre().subscribe((response: any) => {
    }, (err) => {
    });
    this.get();
  }

  nbJours(timestamp: number, quotaProchainCode: number): string {
    const dateExpiration = new Date(timestamp);
    dateExpiration.setDate(dateExpiration.getDate() + quotaProchainCode);
    const tempsRestant = dateExpiration.getTime() - this.actuel;
    if (tempsRestant < 0) return "Fini";
    const jours = Math.floor(tempsRestant / (1000 * 60 * 60 * 24));
    const heures = Math.floor((tempsRestant % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    return `Durée : ${jours > 0 ? jours + ' jours ' : ''}${heures > 0 ? heures + ' heures ' : ''}`;
  }

  nbActive(): number {
    if (!this.slots || this.slots.length === 0) return 0;
    
    return this.slots.flat().filter((s: any) => {
      if (!s.dernierRechargement || !s.dernierRechargementDuree) return false;
      
      const expiration = new Date(s.dernierRechargement * 1000);
      expiration.setDate(expiration.getDate() + s.dernierRechargementDuree);
      return expiration.getTime() - this.actuel >= 0;
    }).length;
  }

  couleur(timestamp: number, duree: number): string {
    if (!timestamp || !duree) return "black";
    
    const expiration = new Date(timestamp * 1000);
    expiration.setDate(expiration.getDate() + duree);
    const restant = expiration.getTime() - this.actuel;
    
    if (restant < 0) return "red";
    
    const jours = Math.floor(restant / (1000 * 60 * 60 * 24));
    if (jours === 0) return "red";
    if (jours === 1) return "orange";
    return "black";
  }

  multipleChoose(type: string, index: number): void {
    if (type === 'all') {
      this.all = !this.all;
    } else if (type === 'colonne') {
      this.colonne[index] = !this.colonne[index];
    } else {
      this.ligne[index] = !this.ligne[index];
    }
    if (this.amount != -1) {
      for (const row of this.slots) {
        for (const slot of row) {
          const [ligne, colonne] = slot.port.split('.').map(Number);
          if (type === 'all') {
            slot.asRecharger = this.all ? this.amount : '';
          } else if (type === 'colonne' && index + 1 === colonne) {
            slot.asRecharger = this.colonne[index] ? this.amount : '';
          } else if (type === 'ligne' && index + 1 === ligne) {
            slot.asRecharger = this.ligne[index] ? this.amount : '';
          }
        }
      }
    }
  }

  get(): void {
    this.isLoading = true;
    this.rechargesService.export({}).subscribe((response: any) => {
      if (response.status && response.data?.recharges) {
        const brut = response.data.recharges;

        const regroupées = brut.reduce((acc: any[], r: any) => {
          const key = `${r.operateur}-${r.montant}`;
          let groupe = acc.find(g => g.key === key);
          if (!groupe) {
            const id = acc.length + 1;
            groupe = {
              id,
              key,
              operateur: r.operateur,
              montant: r.montant,
              total: 0
            };
            acc.push(groupe);
          }
          groupe.total++;
          return acc;
        }, []);

        this.detail = regroupées;
        
        // Créer des slots par défaut après avoir traité les recharges
        this.createDefaultSlots();
      }
      this.isLoading = false;
    }, (error) => {
      this.isLoading = false;
    });
  }

  // ===== CRÉATION DES SLOTS PAR DÉFAUT =====
  private createDefaultSlots(): void {
    // Créer une grille de slots par défaut 16x4
    this.slots = [];
    for (let ligne = 0; ligne < 16; ligne++) {
      const row: any[] = [];
      for (let colonne = 0; colonne < 4; colonne++) {
        const portNumber = ligne + 1;
        const slotNumber = colonne + 1;
        row.push({
          port: `${portNumber}.${slotNumber}`,
          actif: true, // Par défaut, tous les ports sont actifs
          asRecharger: '',
          codeEnAttente: '',
          dernierRechargement: 0,
          dernierRechargementOperateur: '',
          dernierRechargementMontant: 0,
          dernierRechargementDuree: 0,
          quotaProchainCode: 0,
          _id: `slot_${portNumber}_${slotNumber}` // ID temporaire
        });
      }
      this.slots.push(row);
    }
  }

  getDetailRecharges(): void {
    this.globalService.get('/SP-GetAllRecharges').subscribe((response) => {
      if (response.status) {
        this.detail = response.detail;
      }
    });
  }

  fileChange(e: any): void {
    const file = e.target.files[0];
    if (!file) {
      this.files = [];
      return;
    }
    this.files = [file];
  }

  fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }

  async import(): Promise<void> {
    if (!this.files || this.files.length === 0) {
      alert('Veuillez sélectionner un fichier');
      return;
    }

    const file = this.files[0];
    this.upload = true;
    this.nbImporter = 0;

    try {
      const base64 = await this.fileToBase64(file);
      const base64Data = base64.split(',')[1];

      const importData = {
        fileName: file.name,
        fileBase64: base64Data
      };

      this.rechargesService.import(importData).subscribe((response) => {
        if (response.status) {
          this.nbImporter = response.data?.total || 0;
          this.upload = false;
          this.get();
          alert(`${this.nbImporter} recharge(s) importée(s) avec succès`);
        } else {
          this.upload = false;
          alert('Erreur lors de l\'importation: ' + (response.message || 'Erreur inconnue'));
        }
      }, (error) => {
        this.upload = false;
        alert('Erreur lors de l\'importation: ' + (error.message || 'Erreur réseau'));
      });
    } catch (error: any) {
      this.upload = false;
      alert('Erreur lors de la conversion du fichier: ' + (error?.message || 'Erreur inconnue'));
    }
  }

  export(): void {
    this.rechargesService.export({}).subscribe((response) => {
      if (response.status) {
        window.open(`${this.globalService.url}/documents/recharges/${response.filename}.xlsx`);
      } else {
        alert('Erreur lors de la modification');
      }
    });
  }

  clic_checkbox(port: string): void {
    for (const row of this.slots) {
      for (const slot of row) {
        if (slot.port === port) {
          slot.asRecharger = slot.asRecharger === '' ? this.amount : '';
          return;
        }
      }
    }
  }

  removeRecharge(port: string): void {
    for (const row of this.slots) {
      for (const slot of row) {
        if (slot.port === port) {
          this.globalService.get(`/SP-RemoveRechargeById?id=${slot._id}`).subscribe((response) => {
            if (response.status) {
              this.get();
            } else {
              alert('Erreur lors de la modification');
            }
          });
          return;
        }
      }
    }
  }

  recharger(): void {
    if (!this.amount || this.amount === -1) return;

    const selected = this.detail.find((d: any) => d.id === this.amount);
    if (!selected || this.quotaProchainCode == null || this.quotaProchainCode < 0) return;

    const ids = this.slots
      .flat()
      .filter((s: any) => s.asRecharger === this.amount && !s.codeEnAttente)
      .map((s: any) => s._id);

    if (ids.length > 0) {
      this.globalService.post('/SP-RechargePorts', {
        montant: selected.montant,
        operateur: selected.operateur,
        quotaProchainCode: this.quotaProchainCode,
        ids
      }).subscribe((response) => {
        if (response.status) {
          this.get();
        } else {
          alert('Erreur lors de la modification');
        }
      });
    }
  }

  getNbPortsActifs(): number {
    if (!this.slots || this.slots.length === 0) return 0;
    return this.slots.flat().filter((s: any) => s.actif).length;
  }

  getNbPortsSelectionnes(): number {
    if (!this.slots || this.slots.length === 0) return 0;
    return this.slots.flat().filter((s: any) => s.asRecharger).length;
  }

  getNbCodesEnAttente(): number {
    if (!this.slots || this.slots.length === 0) return 0;
    return this.slots.flat().filter((s: any) => s.codeEnAttente).length;
  }

  getSlotClass(slot: any): string {
    if (!slot.actif) return 'slot-inactif';
    if (slot.asRecharger) return 'slot-selectionne';
    if (slot.codeEnAttente) return 'slot-en-attente';
    return 'slot-normal';
  }

  getExpirationBadgeClass(timestamp: number, duree: number): string {
    if (!timestamp || !duree) return 'bg-secondary';
    
    const expiration = new Date(timestamp * 1000);
    expiration.setDate(expiration.getDate() + duree);
    const restant = expiration.getTime() - this.actuel;
    
    if (restant < 0) return 'bg-danger';
    
    const jours = Math.floor(restant / (1000 * 60 * 60 * 24));
    if (jours === 0) return 'bg-danger';
    if (jours === 1) return 'bg-warning';
    if (jours <= 7) return 'bg-info';
    return 'bg-success';
  }
}
